class Error {
    constructor() {
        this.error = { message: "N/A" };
        this.message = "Unhandled error occurred, please contact support team.";
        this.description = "";
    }
}

export default Error;
